import { AppConfig } from 'AppConfig';

const { domain, apiPath, userPath, extendedprofilePath } = AppConfig.utmRegistration;

const API_URL = `${domain}/${apiPath}/${userPath}/${extendedprofilePath}`;

export { API_URL };
